<template>
  <v-img
    :src="building.image"
    class="white--text align-end"
    gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
    height="240px"
  >
    <v-card-actions>
      <v-card-title class="text-h4" v-text="building.title"></v-card-title>

      <v-spacer></v-spacer>
      <slot></slot>
      <base-btn class="ma-1" dark icon :href="building.link" target="_blank">
        <v-icon>mdi-open-in-new</v-icon>
      </base-btn>
    </v-card-actions>
  </v-img>
</template>
<script>
export default {
  data() {
    return {
      loading: false,
      selection: 1,
    };
  },

  computed: {
    building() {
      return this.$store.getters.building;
    },
  },

  methods: {
    reserve() {
      this.loading = true;

      setTimeout(() => (this.loading = false), 2000);
    },
  },
};
</script>
